module.exports = __webpack_public_path__ + "img/c5.1d643e71.jpg";